import * as classes from "../css/about-me-physiolymp.module.css";
import imageFrame from "../images/designelement-bilderrahmen-viereck hoch.svg";
import imageTriangleSmall from "../images/physiotherapeut-mit-begeisterung-dreieck-klein.svg";
import imageTriangleLarge from "../images/physiotherapeut-mit-begeisterung-dreieck-groß.svg";
import tim from "../images/tim-martin-case-study-foto.png"
import { transition } from "./util/transition";
import React from "react";
import { useInView } from "react-intersection-observer";

export function UeberMich(): React.ReactElement {
  const { ref, inView } = useInView({
    threshold: 0,
    rootMargin: "400px 0px -400px 0px",
    initialInView: true,
  });

  return (
    <>
      <div className="relative z-50">
        <span id="ueber-mich" className={classes.anchor} />
      </div>
      <section
        className="relative z-20 overflow-hidden"
        style={{
          marginTop: "-28.5rem",
          transform: "skewY(9.2deg)",
        }}
        ref={ref}
      >
        <div
          className="bg-gray-200 text-black"
          style={{
            transform: "skewY(-14.2deg)",
            marginTop: "15rem",
            marginBottom: "-14.5rem",
          }}
        >
          <div className={classes.container}>
            <h2
              className="text-right lg:text-left"
              style={{
                transition: transition(inView, 0),
                transform: `translateY(${inView ? "0" : "-1rem"})`,
                opacity: inView ? 1 : 0,
              }}
              data-test="ueber-mich-title"
            >
              <span className={classes.subtitle}>Physiotherapeut mit</span>{" "}
              <span className={classes.title}>Begeisterung</span>
            </h2>
            <img
              src={imageFrame}
              alt="Tim Bild"
              width="200"
              className={classes.imageFrame}
              style={{
                transition: transition(inView, 700),
                transform: `rotate(10deg) translateY(${
                  inView ? "0" : "-1rem"
                })`,
                opacity: inView ? 1 : 0,
              }}
            />
            <img
              aria-hidden="true"
              src={imageTriangleLarge}
              alt=""
              width="20"
              className={classes.largeTriangle}
              style={{
                transition: transition(inView, 850),
                transform: `rotate(var(--rotation)) translateY(${
                  inView ? "0" : "-1rem"
                })`,
                opacity: inView ? 1 : 0,
              }}
            />
            <img
              aria-hidden="true"
              src={imageTriangleSmall}
              alt=""
              width="20"
              className={classes.smallTriangle}
              style={{
                transition: transition(inView, 1000),
                transform: `rotate(var(--rotation)) translateY(${
                  inView ? "0" : "-1rem"
                })`,
                opacity: inView ? 1 : 0,
              }}
            />
            <div
              className={classes.image}
              style={
                {
                  "--background": `url(${tim})`,
                  transition: transition(inView, 700),
                  transform: `rotate(var(--rotation)) translate(var(--translation-x), var(--translation-y)) translateY(${
                    inView ? "0" : "-1rem"
                  })`,
                  opacity: inView ? 1 : 0,
                } as never
              }
            />
            <div className="flex flex-col-reverse xl:flex-col">
              <div
                className={classes.text}
                style={{
                  transition: transition(inView, 150),
                  transform: `translateY(${inView ? "0" : "-1rem"})`,
                  opacity: inView ? 1 : 0,
                }}
              >
                Seit 2014 arbeite ich als <b>Physiotherapeut</b>. Nachdem ich
                2019 den Schritt in die Teilselbständigkeit gegangen bin, wurde
                mir klar, dass mir die <b>Physiotherapie</b> allein nicht
                ausreicht. Ich begann mit meiner <b>Osteopathie-Fortbildung</b>,
                die ich im Oktober 2021 abschloß. Seit 2021 betreue ich die
                Tischtennis-Bundesligamannschaft des FC Saarbrücken und andere
                Tischtennisprofis. So konnte ich meine Leidenschaft zum Sport
                mit meiner Arbeit verknüpfen. Mein zweites Standbein ist das „
                <b>Betriebliche Gesundheitsmanagement</b>“, dass mich meine
                Arbeit <b>präventiv</b> und in den Alltag anderer einbauen
                lässt. Vor Kurzem habe ich mir den Traum von einer eigenen
                Praxis erfüllt. Ich hoffe wir sehen uns bald dort!
              </div>
              <div
                className={classes.author}
                style={{
                  transition: transition(inView, 300),
                  transform: `translateY(${inView ? "0" : "-1rem"})`,
                  opacity: inView ? 1 : 0,
                }}
              >
                Tim Martin
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
